import axios from "./axiosConfig";
import { apis } from './params';

export function getServiceabilityService(_param: any) {
    return axios({
        "method": "Get",
        "url": apis.GET_SERVICEABILITY + _param
    })
}

export function downloadServiceabilityService(_param: any) {
    return axios({
        "method": "Get",
        "url": apis.DOWNLOAD_SERVICEABILITY + _param,
        "responseType": "blob"
    })
}

export function uploadServiceabilityFileService(_data: any) {
    return axios({
        "method": "Post",
        "url": apis.UPLOAD_SERVICEABILITY_FILE + _data.param,
        "data": _data.data,
        "headers": {
            "Content-Type": "multipart/form-data"
        }
    })
}

export interface ServiceabilityBulkCreatePayload {
    msnList: string[];
    categoryList: string[];
    pincodeList: string[];
    isCod: boolean;
    isServiceable: boolean;
    cityId?: number | null;
    countryCode?: number;
}

export function bulkCreateServiceabilityService(body: ServiceabilityBulkCreatePayload, email: string) {
    return axios({
        method: "Post",
        url: `${apis.BULK_CREATE_SERVICEABILITY}?email=${encodeURIComponent(email)}`,
        data: body,
        timeout: 120000, // 2-minute timeout for large batch processing (up to 250k combinations)
        headers: {
            "Content-Type": "application/json",
            "X-Trace-Id": "cms-frontend-manual-bulk"
        }
    });
}